module.exports = __webpack_public_path__ + "img/download.7fde1430.svg";